export interface PlanTemplateConfiguration {
  planType: PlanTemplateType
  paperFormat: PlanTemplatePaperFormat
  orientation: PlanTemplateOrientation
}

export const planTemplateConfigurationKey = ({
  planType,
  paperFormat,
  orientation,
}: PlanTemplateConfiguration): string => `${planType}-${paperFormat}-${orientation}`

export const findCustomPlanTemplate = (
  files: CustomerFile<PlanTemplateAdditionalData>[],
  configuration: PlanTemplateConfiguration,
): CustomerFile<PlanTemplateAdditionalData> | undefined => {
  const matching = files.filter(
    file =>
      file.additional_data?.kind === 'pdfPlanTemplate' &&
      file.additional_data.planType === configuration.planType &&
      file.additional_data.paperFormat === configuration.paperFormat &&
      file.additional_data.orientation === configuration.orientation,
  )

  return [...matching].sort((a, b) => (a.created || '').localeCompare(b.created || '')).pop()
}
